import { Text } from '../../Text';
import type { AlertDescriptionProps } from './AlertDescription.types';

export const AlertDescription = (props: AlertDescriptionProps) => <Text {...props} />;
